<div class="w-full max-w-6xl p-4 sm:p-8">
    <div class="prose prose-sm !max-w-100 col-span-4 mb-5">
        <h2>{{ 'label_system_settings' | translate }}</h2>
    </div>
    <span class="separator-line block mb-[px]"></span>
    <mat-tab-group
        class="w-full sm:px-2 hjalp-tab-group fade-in-left"
        [animationDuration]="'0'"
        [(selectedIndex)]="selectedPanelIndex"
        (selectedTabChange)="tabChanged($event)"
    >
        @if (lsrauthService.inRole(userDetails, userRoles.SYSTEM_SETTINGS)) {
            <mat-tab label="{{ 'label_incident_and_requests' | translate }}">
                <app-settings-configs-assists></app-settings-configs-assists>
            </mat-tab>
        }
        <!-- <mat-tab label="Gildi"> -->
        @if (
            lsrauthService.inRole(userDetails, userRoles.CONFIGS_SUPERUSER_ROLE) ||
            lsrauthService.inRole(userDetails, userRoles.EDIT_CONFIGS_ROLE)
        ) {
            <mat-tab [label]="'label_value' | translate">
                <app-settings-configs-configs></app-settings-configs-configs>
            </mat-tab>
        }
    </mat-tab-group>
</div>
